import { j as t } from "../../../../_virtual/jsx-runtime.js";
import a from "../../../../assets/icons/ArrowDown.js";
import { cn as I } from "../../../../lib/utils.js";
import { DIRECTION as f } from "./types.js";
const s = 62, r = 32, u = 10, x = s / 2, d = u / 2, b = ({
  x: e,
  direction: n,
  hidden: c,
  ahiScoreThreshold: m
}) => {
  if (c)
    return null;
  const o = n === f.UP, i = o ? "bg-blue-300" : "bg-blue-100", l = I("mr-1", o ? "transform rotate-180" : "");
  return /* @__PURE__ */ t.jsx(
    "foreignObject",
    {
      x: e - x + d,
      y: 0 + (o ? 0 : r),
      width: s,
      height: r,
      children: /* @__PURE__ */ t.jsxs(
        "div",
        {
          className: `flex items-center justify-center ${i} rounded-md px-2 py-1 w-full h-full text-sm`,
          children: [
            /* @__PURE__ */ t.jsx(a, { className: l }),
            /* @__PURE__ */ t.jsx("span", { className: "text-gray-700 font-medium", children: m })
          ]
        }
      )
    }
  );
};
export {
  b as default
};
